import { useEffect } from 'react';
import QuoteStore from '../../modules/quote/store/QuoteStore';
import { getParameterByName } from '../../utils';

function setQuoteOrigin() {
  const origin = getParameterByName('quoteorigin');

  if (!origin) {
    return;
  }
  QuoteStore.origin = +origin;
}

export default function useQuoteOrigin() {
  useEffect(() => {
    setQuoteOrigin();
  }, []);
}
